import isArray from "lodash/isArray";
import isPlainObject from "lodash/isPlainObject";
import type { ChildrenProp } from "../types";

export const isObj = (v: unknown): v is Record<string, unknown> =>
  v !== null && typeof v === "object" && isPlainObject(v);

export const isChildrenProp = (prop: unknown): prop is ChildrenProp => {
  if (!isObj(prop)) return false;
  const maybe = prop as Partial<ChildrenProp> & {
    prop?: unknown;
    type?: unknown;
    value?: unknown;
  };
  const hasCorrectType = maybe.type === "children";
  const hasCorrectProp = maybe.prop === undefined || maybe.prop === "children";
  return hasCorrectType && hasCorrectProp && isArray(maybe.value);
};
